module.exports = __webpack_public_path__ + "img/CompScope_Mag_2_Focus_0.256614da.png";